/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { theme, pxToEm, disable, themeV2 } from '@insticator/insticator-ui';
import { hoverTransition } from '../../../../utils/styles/general';



/* ++++++++++ --------------- LINK CONTROL : STYLES --------------- ++++++++++ */
export default {
  linkcontrol: {
    alignItems: 'center',
    border: 'none',
    borderRadius: pxToEm(18),
    color: props => props.selected ? themeV2.color.primary.main : themeV2.color.base.gray.secondary,
    cursor: 'pointer',
    display: 'flex',
    fontSize: pxToEm(14),
    height: '36px',
    justifyContent: 'center',
    marginRight: pxToEm(10),
    minWidth: '86px',
    transition: 'filter .15s ease-in 0s',
    '&:hover': {
        color: themeV2.color.primary.main
    },
    '&:last-child': {
        marginRight: '0px'
    },
    '&.selected-true': {
        pointerEvents: 'none',
        backgroundColor: `${themeV2.color.background.light.blue} !important`
    },
    '&.disabled-true': {
        pointerEvents: 'none'
    }
  }
};
